import React, { useState, useMemo } from "react";
import { Box, Paper, Typography, Chip, Button } from "@mui/material";
import CardRenderer from "../renderer/CardRenderer";
import { evaluateForm } from "../engine/logicEngine";

/** Pré-visualização interativa usando o mesmo renderer do paciente. */
export default function PreviewPane({ definition, title, description }) {
  const [values, setValues] = useState({});
  const evaluation = useMemo(() => evaluateForm(definition, values), [definition, values]);
  const calcs = definition.calculations || [];

  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Paper variant="outlined" sx={{ flex: 1, maxWidth: 720, overflow: "hidden" }}>
        <CardRenderer
          embedded
          definition={definition}
          values={values}
          onChange={(id, v) => setValues((prev) => ({ ...prev, [id]: v }))}
          onSubmit={() => alert("Preview: respostas válidas! (nada é salvo no preview)")}
          title={title}
          description={description}
        />
      </Paper>

      <Box sx={{ width: 260 }}>
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle2">Escores calculados</Typography>
          {calcs.length === 0 && <Typography variant="caption" color="text.secondary">Nenhum cálculo definido.</Typography>}
          {calcs.map((c) => (
            <Box key={c.id} sx={{ display: "flex", justifyContent: "space-between", py: 0.5 }}>
              <Typography variant="body2">{c.name}</Typography>
              <Chip size="small" label={String(evaluation.computed[c.id] ?? 0)} color="primary" />
            </Box>
          ))}
        </Paper>

        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle2">Estado</Typography>
          <Typography variant="body2">
            Válido: <strong style={{ color: evaluation.valid ? "#2e7d32" : "#d32f2f" }}>
              {evaluation.valid ? "sim" : "não"}
            </strong>
          </Typography>
          <Button size="small" sx={{ mt: 1 }} onClick={() => setValues({})}>Limpar respostas</Button>
        </Paper>
      </Box>
    </Box>
  );
}
